export const ADULT_MEASUREMENTS = {
  front: {
    legendLeft: {
      title: "3”",
      description: "XS-XL"
    },
    legendRight: {
      title: "4”",
      description: "2XL+"
    }
  },
  back: {
    legendLeft: {
      title: "4”",
      description: "XS-XL"
    },
    legendRight: {
      title: "5”",
      description: "2XL+"
    }
  },
  frontLeftChest: {
    legendLeft: {
      title: "3”",
      description: "XS-XL"
    },
    legendRight: {
      title: "4”",
      description: "2XL+"
    }
  }
};

export const YOUTH_MEASUREMENTS = {
  front: {
    legendLeft: {
      title: "2”",
      description: "XS-XL"
    },
    legendRight: undefined
  },
  back: {
    legendLeft: {
      title: "3”",
      description: "XS-XL"
    },
    legendRight: undefined
  },
  frontLeftChest: {
    legendLeft: {
      title: "2”",
      description: "XS-XL"
    },
    legendRight: undefined
  }
};
